webpackJsonp([2],{

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_main_page_js__ = __webpack_require__(1126);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20534cac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_page_vue__ = __webpack_require__(1310);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_main_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20534cac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1056);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  selectSettingRice: function selectSettingRice(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/settingrice').then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  saveRiceSummery: function saveRiceSummery(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/ricesummery/save', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  decreaseRemain: function decreaseRemain(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/remainstock/decrease', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  insertWaitingTransferStock: function insertWaitingTransferStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/pos/insertwaitingtransfer', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  selectTransferStock: function selectTransferStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/pos/selecttranfer', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  selectOutTransferStock: function selectOutTransferStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/pos/selectouttranfer', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  cancelTransferStock: function cancelTransferStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/pos/canceltransfer', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  approveOutTransferStock: function approveOutTransferStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/pos/approveouttransfer', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  approveInTransferStock: function approveInTransferStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/pos/approveintransfer', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  notificationTransfer: function notificationTransfer(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/pos/notificationtransfer', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  changeActivity: function changeActivity(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/pos/changeactivity', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  confirmActivity: function confirmActivity(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/transferstock/pos/confirmActivity', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  updateStock: function updateStock(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/stock/pos/updateStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  resetStockEgg: function resetStockEgg(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/stock/resetstockegg', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getProductEgg: function getProductEgg(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/confirmsale/getProductEgg').then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getProductRiceMar: function getProductRiceMar(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/confirmsale/getProductRiceMar' + header).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getProductEggSummarySale: function getProductEggSummarySale(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/confirmsale/getProductEggSummarySale', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  getProductRiceMarSummarySale: function getProductRiceMarSummarySale(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/confirmsale/getProductRiceMarSummarySale', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  saveConfirmSaleEgg: function saveConfirmSaleEgg(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/confirmsale/saveConfirmSaleEgg', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  saveConfirmSaleRiceMar: function saveConfirmSaleRiceMar(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/confirmsale/saveConfirmSaleRiceMar', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  deleteSaleRiceMar: function deleteSaleRiceMar(body, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURLV2 + '/api/confirmsale/deleteSaleRiceMar', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  }
  // getProductEggSummarySale (header, success, error) {
  //   Vue.axios.get(config.baseURLV2 + '/api/confirmsale/getProductEggSummarySale').then(
  //     response => {
  //       success(response)
  //     },
  //     response => {
  //       error(response)
  //     }
  //   )
  // },
  // getProductRiceMarSummarySale (header, success, error) {
  //   Vue.axios.get(config.baseURLV2 + '/api/confirmsale/getProductRiceMarSummarySale').then(
  //     response => {
  //       success(response)
  //     },
  //     response => {
  //       error(response)
  //     }
  //   )
  // }

});

/***/ }),

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  uploadImage: function uploadImage(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'upload/v1/upload/image', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  isLogin: function isLogin(URL, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/signin', body).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addUser: function addUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/add/user', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  listUser: function listUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/list/user', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  removeUser: function removeUser(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/remove/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getRole: function getRole(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/list/role', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  userDetail: function userDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/get/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  userUpdate: function userUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'auth/v1/update/user/code', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  configDetail: function configDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  confighUpdate: function confighUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/branch/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHostShift: function getHostShift(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/host/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  companyDetail: function companyDetail(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'company/v1/list', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  companyUpdate: function companyUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  hostUpdate: function hostUpdate(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'company/v1/host/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1056:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  baseURL: 'https://centralize.undefined.co.th:4441',
  // baseURL: 'http://localhost:3001',
  // baseURLV2: 'https://spare-nodejs-api.undefined.co.th:4439'
  baseURLV2: 'http://localhost:6100'
  // baseURLV2: 'https://marim-api-santithum.undefined.co.th:4439'
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ 1058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  list: function list(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'calendar/v1/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  new: function _new(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'calendar/v1/new', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelCalendar: function cancelCalendar(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'calendar/v1/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1063:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(1056);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* unused harmony default export */ var _unused_webpack_default_export = ({
  getMenimumStock: function getMenimumStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/minimumStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  insertMinimumStock: function insertMinimumStock(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/item/insertMinimumStock', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  },
  updateHoldBill: function updateHoldBill(body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].baseURL + '/api/sale/updateHoldBill', body).then(function (response) {
      success(response);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1064:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_undefined_v2__ = __webpack_require__(1051);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hourSelected: '1',
      nowDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()),
      hourList: [1, 3, 5, 7, 15, 30],
      description: '',
      defaultValue: __WEBPACK_IMPORTED_MODULE_0_moment___default()('00:00:00', 'HH:mm:ss'),
      messageDescription: '',
      result_detail: {
        id: 0,
        title: '',
        start: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).format('DD/MM/YYYY HH:mm:ss'),
        activityDate: '',
        documentDate: '',
        color: 'White',
        status: 0,
        description: '',
        messageDescription: '',
        all_day: false
      }
    };
  },

  methods: {
    moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
    toggle: function toggle() {
      $('button[name="hourBtn"]').toggleClass('active').siblings().not(this).removeClass('active');
    },
    removeHowver: function removeHowver() {
      // eslint-disable-next-line no-undef
      $('button[name="hourBtn"]').toggleClass('active').siblings().not(this).removeClass('active');
    },
    selectHour: function selectHour($event) {
      this.nowDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).add($event.target.value, 'day');
    },
    selectDateStart: function selectDateStart(current) {
      // console.log(current)
      return current && current.valueOf() <= __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).add(-1, 'day');
    },
    getDetail: function getDetail() {
      this.result_detail = this.$store.state.activity_detail;
      this.result_detail.activityDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.$store.state.activity_detail.start).format('DD/MM/YYYY HH:mm:ss');
      this.result_detail.documentDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.$store.state.activity_detail.create_time).format('DD/MM/YYYY HH:mm:ss');
      this.messageDescription = '';
      this.description = '';
    },
    saveChangeActivity: function saveChangeActivity() {
      var _this = this;

      this.result_detail['description'] = this.description;
      this.result_detail['messageDescription'] = this.messageDescription;
      this.result_detail['change_date'] = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(this.nowDate)).format('YYYY-MM-DD HH:mm:ss');

      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_1__services_service_undefined_v2__["a" /* default */].changeActivity({
        data: this.result_detail
      }, this.header, function (results) {
        if (results.data.status) {
          _this.$store.commit('Loading');
          // eslint-disable-next-line no-undef
          _this.$store.state.activity_detail.status = 3;
          _this.$store.state.activity_detail.start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(_this.nowDate)).format('YYYY-MM-DD HH:mm:ss');
          _this.$store.state.activity_detail.description = _this.description;
          _this.$store.state.activity_detail.messageDescription = _this.messageDescription;

          $('#alertPostponse').modal('hide');
          _this.$notification['success']({
            message: 'แจ้งเตือน',
            description: 'เลื่อนเวลาการนัดหมายสำเร็จ'
          });
        } else {
          _this.$store.commit('Loading');
          _this.$notification['warning']({
            message: 'แจ้งเตือน',
            description: 'เลื่อนเวลาการนัดหมายไม่สำเร็จ'
          });
        }
      }, function (errors) {
        _this.$store.commit('Loading');
        _this.$notification['warning']({
          message: 'เลื่อนเวลาการนัดหมายไม่สำเร็จ',
          description: errors.data.message
        });
      });
    }
  },
  mounted: function mounted() {
    this.nowDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.nowDate).add(1, 'days');
    $('#alertPostponse').on('show.bs.modal', function () {
      this.getDetail();
      // eslint-disable-next-line no-extra-bind
    }.bind(this));
  }
});

/***/ }),

/***/ 1065:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_undefined_v2__ = __webpack_require__(1051);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hourSelected: '1',
      nowDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()),
      hourList: [1, 3, 5, 7, 15, 30],
      description: '',
      defaultValue: __WEBPACK_IMPORTED_MODULE_0_moment___default()('00:00:00', 'HH:mm:ss'),
      messageDescription: '',
      result_detail: {
        id: 0,
        title: '',
        start: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).format('DD/MM/YYYY HH:mm:ss'),
        activityDate: '',
        documentDate: '',
        color: 'White',
        status: 0,
        description: '',
        messageDescription: '',
        all_day: false
      }
    };
  },

  methods: {
    moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
    toggle: function toggle() {
      $('button[name="hourBtn"]').toggleClass('active').siblings().not(this).removeClass('active');
    },
    removeHowver: function removeHowver() {
      // eslint-disable-next-line no-undef
      $('button[name="hourBtn"]').toggleClass('active').siblings().not(this).removeClass('active');
    },
    selectHour: function selectHour($event) {
      this.nowDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).add($event.target.value, 'day');
    },
    selectDateStart: function selectDateStart(current) {
      // console.log(current)
      return current && current.valueOf() < __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date());
    },
    getDetail: function getDetail() {
      this.result_detail = this.$store.state.activity_detail;
      this.result_detail.activityDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.$store.state.activity_detail.start).format('DD/MM/YYYY HH:mm:ss');
      this.result_detail.documentDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.$store.state.activity_detail.create_time).format('DD/MM/YYYY HH:mm:ss');
      this.messageDescription = '';
      this.description = '';
    },
    saveConfirmActivity: function saveConfirmActivity() {
      var _this = this;

      this.result_detail['description'] = this.description;
      this.result_detail['messageDescription'] = this.messageDescription;
      this.result_detail['change_date'] = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(this.nowDate)).format('YYYY-MM-DD HH:mm:ss');

      this.$store.commit('Loading');
      __WEBPACK_IMPORTED_MODULE_1__services_service_undefined_v2__["a" /* default */].confirmActivity({
        data: this.result_detail
      }, this.header, function (results) {
        if (results.data.status) {
          _this.$store.commit('Loading');
          // eslint-disable-next-line no-undef
          _this.$store.state.activity_detail.status = 1;
          _this.$store.state.activity_detail.start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(_this.nowDate)).format('YYYY-MM-DD HH:mm:ss');
          _this.$store.state.activity_detail.description = _this.description;
          _this.$store.state.activity_detail.messageDescription = _this.messageDescription;

          $('#alertSuccess').modal('hide');
          _this.$notification['success']({
            message: 'แจ้งเตือน',
            description: 'จัดการนัดหมายสำเร็จ'
          });
        } else {
          _this.$store.commit('Loading');
          _this.$notification['warning']({
            message: 'แจ้งเตือน',
            description: 'จัดการนัดหมายไม่สำเร็จ'
          });
        }
      }, function (errors) {
        _this.$store.commit('Loading');
        _this.$notification['warning']({
          message: 'จัดการนัดหมายไม่สำเร็จ',
          description: errors
        });
      });
    }
  },
  mounted: function mounted() {
    this.nowDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.nowDate).add(1, 'days');
    $('#alertSuccess').on('show.bs.modal', function () {
      this.getDetail();
      // eslint-disable-next-line no-extra-bind
    }.bind(this));
  }
});

/***/ }),

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_alert_postponse_js__ = __webpack_require__(1064);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3427be7e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_postponse_vue__ = __webpack_require__(1078);
function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3427be7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_alert_postponse_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3427be7e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_postponse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1070:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_alert_success_js__ = __webpack_require__(1065);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f304d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_success_vue__ = __webpack_require__(1081);
function injectStyle (ssrContext) {
  __webpack_require__(1079)
}
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_alert_success_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f304d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_success_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1077);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1017)("6a4db7a9", content, true, {});

/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1016)(true);
// imports


// module
exports.push([module.i, ".container-fluid[data-v-3427be7e]{padding:0;margin:0}.appoint-detail[data-v-3427be7e]{background-color:#fcf29f;border-radius:6px}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/alert_postponse.vue"],"names":[],"mappings":"AACA,kCACE,UAAW,AACX,QAAU,CACX,AACD,iCACE,yBAA0B,AAC1B,iBAAmB,CACpB","file":"alert_postponse.vue","sourcesContent":["\n.container-fluid[data-v-3427be7e] {\n  padding: 0;\n  margin: 0;\n}\n.appoint-detail[data-v-3427be7e] {\n  background-color: #fcf29f;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.result_detail.documentDate))]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.result_detail.title))]),_vm._v(" "),_c('p',[_vm._v("ความสำคัญ\n      "),(_vm.result_detail.color.toLowerCase() == 'white'  )?_c('span',{staticClass:"severity status-white px-1"},[_vm._v("ขาว")]):_vm._e(),_vm._v(" "),(_vm.result_detail.color.toLowerCase() == 'red'  )?_c('span',{staticClass:"severity status-red px-1"},[_vm._v("แดง")]):_vm._e(),_vm._v(" "),(_vm.result_detail.color.toLowerCase() == 'blue'  )?_c('span',{staticClass:"severity status-blue px-1"},[_vm._v("น้ำเงิน")]):_vm._e(),_vm._v(" "),(_vm.result_detail.color.toLowerCase() == 'yellow'  )?_c('span',{staticClass:"severity status-yellow px-1"},[_vm._v("เหลือง")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"container container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 pb-4"},[_c('h5',{staticClass:"mt-2"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"maxlength":"500","rows":"12"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"btn-group",attrs:{"role":"group","data-toggle":"button","aria-label":"hour"}},[_c('div',{staticClass:"col p-0 m-0"},_vm._l((_vm.hourList),function(e,i){return _c('button',{key:i,class:("btn btn-outline-secondary " + (i == 0 ? 'active' : '')),staticStyle:{"width":"50px!important"},attrs:{"name":"hourBtn","id":"hourBtn","type":"button","value":e},on:{"click":function($event){$event.preventDefault();_vm.toggle();
                      _vm.selectHour($event);}}},[_vm._v("\n                    "+_vm._s(e)+"\n                  ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col m-0 p-0"},[_c('div',{staticClass:"appoint-detail p-3"},[_c('h5',[_vm._v("ข้อมูลนัดหมาย")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v("วันที่และเวลา")]),_vm._v(" "),_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"DD/MM/YYYY HH:mm:ss","size":"large","disabledDate":_vm.selectDateStart,"showTime":{
                        defaultValue: _vm.defaultValue
                      }},on:{"change":function($event){return _vm.removeHowver()}},model:{value:(_vm.nowDate),callback:function ($$v) {_vm.nowDate=$$v},expression:"nowDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('h6',[_vm._v("ข้อความนัดหมาย")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.messageDescription),expression:"messageDescription"}],staticClass:"form-control",attrs:{"maxlength":"500","rows":"3"},domProps:{"value":(_vm.messageDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.messageDescription=$event.target.value}}})])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer justify-content-center"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n      ปิด\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveChangeActivity()}}},[_vm._v("\n      ยืนยัน\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"alertPostponseTitle"}},[_vm._v("\n      เลื่อนเวลาการนัดหมาย\n    ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("สถานะ "),_c('span',{staticClass:"text-warning"},[_vm._v("รอดำเนินการ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1080);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1017)("c16b11e4", content, true, {});

/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1016)(true);
// imports


// module
exports.push([module.i, ".modal-body>p{margin-bottom:0}.severity{font-size:10px;border:1px solid #000}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/alert_success.vue"],"names":[],"mappings":"AACA,cACE,eAAiB,CAClB,AACD,UACE,eAAgB,AAChB,qBAAuB,CACxB","file":"alert_success.vue","sourcesContent":["\n.modal-body > p {\n  margin-bottom: 0;\n}\n.severity {\n  font-size: 10px;\n  border: 1px solid #000;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1081:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body btn-group-vertical"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.result_detail.documentDate))]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.result_detail.title))]),_vm._v(" "),(_vm.result_detail.status == 3)?_c('p',[_vm._v("วันที่และเวลานัดหมาย "+_vm._s(_vm.result_detail.activityDate))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("ความสำคัญ\n      "),(_vm.result_detail.color.toLowerCase() == 'white'  )?_c('span',{staticClass:"severity status-white px-1"},[_vm._v("ขาว")]):_vm._e(),_vm._v(" "),(_vm.result_detail.color.toLowerCase() == 'red'  )?_c('span',{staticClass:"severity status-red px-1"},[_vm._v("แดง")]):_vm._e(),_vm._v(" "),(_vm.result_detail.color.toLowerCase() == 'blue'  )?_c('span',{staticClass:"severity status-blue px-1"},[_vm._v("น้ำเงิน")]):_vm._e(),_vm._v(" "),(_vm.result_detail.color.toLowerCase() == 'yellow'  )?_c('span',{staticClass:"severity status-yellow px-1"},[_vm._v("เหลือง")]):_vm._e()]),_vm._v(" "),_c('h5',{staticClass:"mt-2"},[_vm._v("รายละเอียด")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"maxlength":"500","rows":"3"},domProps:{"value":(_vm.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer justify-content-center"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n      ปิด\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveConfirmActivity()}}},[_vm._v("\n      ยืนยัน\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"alertSuccessTitle"}},[_vm._v("\n      ดำเนินการสำเร็จ\n    ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("สถานะ "),_c('span',{staticClass:"text-warning"},[_vm._v("รอดำเนินการ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_demo_menus_json__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_demo_menus_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_demo_menus_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_demo_menus_role_4_json__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_demo_menus_role_4_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_demo_menus_role_4_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hostlist__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_calendar_day_view__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_alert_postponse__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_alert_success__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_service_calendar__ = __webpack_require__(1058);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HostListView: __WEBPACK_IMPORTED_MODULE_3__components_hostlist__["a" /* default */],
    CalendarDayView: __WEBPACK_IMPORTED_MODULE_4__components_calendar_day_view__["a" /* default */],
    AlertPostponse: __WEBPACK_IMPORTED_MODULE_5__components_alert_postponse__["a" /* default */],
    AlertSuccess: __WEBPACK_IMPORTED_MODULE_6__components_alert_success__["a" /* default */]
  },
  data: function data() {
    return {
      menus: [],
      notiDetail: []
    };
  },

  methods: {
    closePrograme: function closePrograme() {
      if (confirm('กรุณากด alt + F4 เพื่อปิดโปรแกรม')) {
        window.open('', '_self', '');
        window.close();
      }
    },
    goTo: function goTo(path) {
      if (path === '/pos') {
        $('#HostList').modal('show');
      } else if (path === '/alert') {
        $('#notiCalendar').modal('show');
      } else {
        this.$router.push(path);
      }
    },
    notiCalendar: function notiCalendar() {
      var _this = this;

      this.$store.commit('Loading');
      this.now_month = this.dateFormatDMY2(new Date()).split('-');
      var obj = {
        get_year: parseInt(this.now_month[0]),
        get_month: parseInt(this.now_month[1]),
        get_day: parseInt(this.now_month[2])
      };
      __WEBPACK_IMPORTED_MODULE_7__services_service_calendar__["a" /* default */].list(this.REST_URL, {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }, obj, function (result) {
        // console.log(result)
        if (result.response === 'success') {
          _this.events = result.data;
          // console.log(this.events)
          _this.notiDetail = _this.events.filter(function (e) {
            return e.status === 0;
          }).length > 99 ? '99+' : _this.events.filter(function (e) {
            return e.status === 0;
          }).length.toString();
        }
        _this.$store.commit('Loading');
      }, function (error) {
        console.log('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.commit('Loading');
      });
    }
  },
  mounted: function mounted() {
    this.notiCalendar();
    var getUser = localStorage.getItem('user');
    if (getUser !== null) {
      var obj = JSON.parse(getUser);
      if (obj.role_id < 4) {
        this.menus = __WEBPACK_IMPORTED_MODULE_1__static_demo_menus_json___default.a;
      } else {
        this.menus = __WEBPACK_IMPORTED_MODULE_2__static_demo_menus_role_4_json___default.a;
      }
    }
    this.$store.state.historyPage = '';
    this.checkUser();
    $('body').on('hidden.bs.modal', '.modal', function () {
      $(this).removeData('bs.modal');
    });
    $('#notiCalendar').on('hide.bs.modal', function () {
      this.notiCalendar();
      // eslint-disable-next-line no-extra-bind
    }.bind(this));
  }
});

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service__ = __webpack_require__(1053);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data_list: [],
      header: {
        'Access-Token': this.$store.state.token
      }
    };
  },

  methods: {
    setHostShift: function setHostShift(data) {
      this.getListHostDetail(data);
      $('#HostList').modal('hide');
    },
    getListHost: function getListHost() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_service__["a" /* default */].getHostShift(this.REST_URL, this.header, function (result) {
        if (result.response === 'success') {
          _this.data_list = result.data;
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลจุดขายไม่ได้',
            description: result.message
          });
        }
      }, function (_error) {
        _this.$notification['warning']({
          message: 'เชื่อมไม่สำเร็จ'
        });
        // alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
      });
    }
  },
  mounted: function mounted() {
    this.getListHost();
  }
});

/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_calendar__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_undefined__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_alert_postponse__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_alert_success__ = __webpack_require__(1070);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AlertPostponse: __WEBPACK_IMPORTED_MODULE_4__components_alert_postponse__["a" /* default */],
    AlertSuccess: __WEBPACK_IMPORTED_MODULE_5__components_alert_success__["a" /* default */]
  },
  data: function data() {
    return {
      now_month: '',
      events: [],
      isReminder: true,
      remainingData: []
    };
  },

  methods: {
    toggleIsReminder: function toggleIsReminder(page) {
      if (page === 1) {
        this.isReminder = true;
      } else {
        this.isReminder = false;
      }
    },
    getData: function getData() {
      var _this = this;

      this.$store.commit('Loading');
      this.now_month = this.dateFormatDMY2(new Date()).split('-');
      var obj = {
        get_year: parseInt(this.now_month[0]),
        get_month: parseInt(this.now_month[1]),
        get_day: parseInt(this.now_month[2])
      };
      __WEBPACK_IMPORTED_MODULE_2__services_service_calendar__["a" /* default */].list(this.REST_URL, {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }, obj, function (result) {
        // console.log(result)
        if (result.response === 'success') {
          console.log(result.data);
          var data = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(result.data.filter(function (e) {
              return e.status === 0;
            })), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var cal = _step.value;

              data.push(cal);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(result.data.filter(function (e) {
              return e.status === 3;
            })), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _cal = _step2.value;

              data.push(_cal);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(result.data.filter(function (e) {
              return e.status === 1;
            })), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _cal2 = _step3.value;

              data.push(_cal2);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          _this.events = data;
          if (_this.events.length > 0) {
            $('#notiCalendar').modal('show');
          }
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลปฎิทิน',
            description: result.message
          });
        }
        var config = JSON.parse(localStorage.getItem('config'));
        if (config.length > 0) {
          var branchName = config[0].branch_name.replaceAll(' ', '');
          // $('#notiCalendar').modal('show')
          // apiCenter.getMenimumStock(
          //   {
          //     branchName: branchName
          //   },
          //   results => {
          //     $('#notiCalendar').modal('show')
          //     if (results.data.result) {
          //       for (var i = 0; i < results.data.result.length; i++) {
          //         let value = {
          //           text: results.data.result[i].name,
          //           remain: results.data.result[i].stock_qty,
          //           unit: results.data.result[i].stk_unit_code
          //         }
          //         this.remainingData.push(value)
          //       }
          //     }
          //   },
          //   errors => {}
          // )
        }
        _this.$store.commit('Loading');
      }, function (error) {
        console.log('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.commit('Loading');
      });
    },
    goTo: function goTo(path) {
      $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).removeData('bs.modal');
      });
      $('#notiCalendar').modal('hide');
      this.$router.push(path);
    },
    openActivity: function openActivity(data) {
      // console.log(data)
      this.$store.state.activity_detail = data;
    }
  },
  mounted: function mounted() {
    if (sessionStorage.token !== undefined && sessionStorage.token !== 'undefined') {
      this.getData();
    }
  }
});

/***/ }),

/***/ 1302:
/***/ (function(module, exports) {

module.exports = [{"name":"จัดการผู้ใช้งาน","icon":"fas fa-users","path":"/manageusers"},{"name":"สินค้าคงคลัง","icon":"fas fa-store","path":"/managestore"},{"name":"โปรแกรมขาย","icon":"fas fa-cash-register","path":"/pos"},{"name":"สั่งสินค้า","icon":"fas fa-shopping-bag","path":"/order"},{"name":"จัดการเจ้าหนี้","icon":"fas fa-user-secret","path":"/vendor"},{"name":"จัดการลูกหนี้","icon":"fas fa-user-tie","path":"/customer"},{"name":"บิลขาย","icon":"fas fa-print","path":"/reprintsale"},{"name":"ปฏิทิน","icon":"fas fa-calendar-check","path":"/calendar"},{"name":"รายงาน","icon":"fas fa-file-invoice-dollar","path":"/reports"},{"name":"ตั้งค่าระบบ","icon":"fas fa-cogs","path":"/setting"},{"name":"การแจ้งเตือน","icon":"fas fa-solid fa-bell","path":"/alert"}]

/***/ }),

/***/ 1303:
/***/ (function(module, exports) {

module.exports = [{"name":"สินค้าคงคลัง","icon":"fas fa-store","path":"/managestore"},{"name":"โปรแกรมขาย","icon":"fas fa-cash-register","path":"/pos"},{"name":"สั่งสินค้า","icon":"fas fa-shopping-bag","path":"/order"},{"name":"จัดการเจ้าหนี้","icon":"fas fa-user-secret","path":"/vendor"},{"name":"จัดการลูกหนี้","icon":"fas fa-user-tie","path":"/customer"},{"name":"บิลขาย","icon":"fas fa-print","path":"/reprintsale"},{"name":"ปฏิทิน","icon":"fas fa-calendar-check","path":"/calendar"},{"name":"รายงาน","icon":"fas fa-file-invoice-dollar","path":"/reports"},{"name":"การแจ้งเตือน","icon":"fas fa-solid fa-bell","path":"/alert"}]

/***/ }),

/***/ 1304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_hostlist_js__ = __webpack_require__(1127);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7cc2f72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hostlist_vue__ = __webpack_require__(1305);
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_hostlist_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7cc2f72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hostlist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body btn-group-vertical"},_vm._l((_vm.data_list),function(h,i){return _c('button',{directives:[{name:"show",rawName:"v-show",value:(h.active_status === 1),expression:"h.active_status === 1"}],key:'shift' + i,staticClass:"btn btn-outline-success btn-lg",attrs:{"type":"button"},on:{"click":function($event){return _vm.setHostShift(h)}}},[_vm._v("\n        "+_vm._s(h.host_name)+"\n    ")])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"HostListTitle"}},[_vm._v("เลือกจุดขาย")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_calendar_day_js__ = __webpack_require__(1128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_775d84ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_day_view_vue__ = __webpack_require__(1309);
function injectStyle (ssrContext) {
  __webpack_require__(1307)
}
var normalizeComponent = __webpack_require__(494)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_calendar_day_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_775d84ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_day_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1308);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1017)("7867152c", content, true, {});

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1016)(true);
// imports


// module
exports.push([module.i, ".appoint-date-wrapper>p{margin-bottom:0;margin-left:.25rem}ul.timeline{list-style-type:none;position:relative;max-height:380px;overflow-y:scroll;width:100%}ul.timeline:before{content:\" \";background:#d4d9df;display:inline-block;position:absolute;left:29px;width:2px;height:100%;z-index:400}ul.timeline>li{margin:20px 0;padding-left:20px}ul.timeline>li:before{content:\" \";background:#fff;display:inline-block;position:absolute;border-radius:50%;border:3px solid #22c0e8;left:20px;width:20px;height:20px;z-index:400}.remain-items{max-height:310px;overflow-y:scroll}.remain-title{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.btn-reminder{border-bottom-left-radius:5px!important}.btn-remain{border-bottom-right-radius:5px!important}ul.remain{list-style-type:none;position:relative}.btn-outline-danger:focus{-webkit-box-shadow:none!important;box-shadow:none!important}.text-elipse{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:70px}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/calendar_day_view.vue"],"names":[],"mappings":"AACA,wBACE,gBAAiB,AACjB,kBAAqB,CACtB,AACD,YACE,qBAAsB,AACtB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,UAAY,CACb,AACD,mBACE,YAAa,AACb,mBAAoB,AACpB,qBAAsB,AACtB,kBAAmB,AACnB,UAAW,AACX,UAAW,AACX,YAAa,AACb,WAAa,CACd,AACD,eACE,cAAe,AACf,iBAAmB,CACpB,AACD,sBACE,YAAa,AACb,gBAAkB,AAClB,qBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,yBAA0B,AAC1B,UAAW,AACX,WAAY,AACZ,YAAa,AACb,WAAa,CACd,AACD,cACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,cACE,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,cACE,uCAA0C,CAC3C,AACD,YACE,wCAA2C,CAC5C,AACD,UACE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,0BACE,kCAAoC,AAC5B,yBAA4B,CACrC,AACD,aACE,mBAAoB,AACpB,gBAAiB,AACjB,uBAAwB,AACxB,cAAgB,CACjB","file":"calendar_day_view.vue","sourcesContent":["\n.appoint-date-wrapper > p {\n  margin-bottom: 0;\n  margin-left: 0.25rem;\n}\nul.timeline {\n  list-style-type: none;\n  position: relative;\n  max-height: 380px;\n  overflow-y: scroll;\n  width: 100%;\n}\nul.timeline:before {\n  content: \" \";\n  background: #d4d9df;\n  display: inline-block;\n  position: absolute;\n  left: 29px;\n  width: 2px;\n  height: 100%;\n  z-index: 400;\n}\nul.timeline > li {\n  margin: 20px 0;\n  padding-left: 20px;\n}\nul.timeline > li:before {\n  content: \" \";\n  background: white;\n  display: inline-block;\n  position: absolute;\n  border-radius: 50%;\n  border: 3px solid #22c0e8;\n  left: 20px;\n  width: 20px;\n  height: 20px;\n  z-index: 400;\n}\n.remain-items {\n  max-height: 310px;\n  overflow-y: scroll;\n}\n.remain-title {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.btn-reminder {\n  border-bottom-left-radius: 5px !important;\n}\n.btn-remain {\n  border-bottom-right-radius: 5px !important;\n}\nul.remain {\n  list-style-type: none;\n  position: relative;\n}\n.btn-outline-danger:focus {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.text-elipse {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 70px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body btn-group-vertical"},[_c('div',{staticClass:"btn-group btn-group-lg my-2"},[_c('button',{staticClass:"btn btn-outline-danger pt-0 pb-0 btn-reminder",class:{ active: _vm.isReminder },staticStyle:{"font-size":"14px","line-height":"25px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleIsReminder(1)}}},[_vm._v("\n        การนัดหมาย "+_vm._s(_vm.dateFormatDMY(new Date()))+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-danger pt-0 pb-0 btn-remain",class:{ active: !_vm.isReminder },staticStyle:{"font-size":"14px","line-height":"25px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleIsReminder(2)}}},[_vm._v("\n        สินค้าใกล้หมด\n      ")])]),_vm._v(" "),(_vm.isReminder)?_c('ul',{staticClass:"timeline reminder"},_vm._l((_vm.events),function(e,i){return _c('li',{key:'ev' + i},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.dateTimeFormatDMY(e.start)))]),_vm._v(" "),_c('div',[_c('p',{staticClass:"text-elipse"},[_vm._v(_vm._s(e.title))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"d-flex align-items-center"},[(e.status == 1)?[_c('i',{staticClass:"far fa-check-circle fa-lg text-success mr-1"}),_vm._v(" "),_c('div',{staticClass:"appoint-date-wrapper"},[_c('p',{staticClass:"text-success",staticStyle:{"font-size":"12px"}},[_vm._v("\n                      สำเร็จแล้ว "+_vm._s(_vm.dateTimeFormatDMY(e.crete_time))+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-elipse",staticStyle:{"font-size":"10px"}},[_vm._v("\n                      "+_vm._s(e.description)+"\n                    ")])])]:(e.status == 3)?[_c('i',{staticClass:"far fa-clock fa-lg text-warning mr-1"}),_vm._v(" "),_c('div',{staticClass:"appoint-date-wrapper"},[_c('p',{staticClass:"text-warning",staticStyle:{"font-size":"12px"}},[_vm._v("\n                      เลื่อนเวลา "+_vm._s(_vm.dateTimeFormatDMY(e.crete_time))+"\n                    ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"10px"}},[_vm._v("\n                      วันที่และเวลานัดหมาย "+_vm._s(_vm.dateTimeFormatDMY(e.start))+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-elipse",staticStyle:{"font-size":"10px","width":"150px"}},[_vm._v(_vm._s(e.description))])])]:[_c('div',[_c('button',{staticClass:"btn btn-warning pt-0 pb-0",staticStyle:{"color":"#000","font-size":"12px","line-height":"25px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#alertPostponse"},on:{"click":function($event){return _vm.openActivity(e)}}},[_c('i',{staticClass:"far fa-clock mr-1"}),_vm._v("เลื่อนเวลา\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success pt-0 pb-0",staticStyle:{"color":"#000","font-size":"12px","line-height":"25px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#alertSuccess"},on:{"click":function($event){return _vm.openActivity(e)}}},[_c('i',{staticClass:"far fa-check-circle mr-1",staticStyle:{"color":"#000"}}),_vm._v("\n                      สำเร็จ\n                    ")])])]],2)])])])}),0):_vm._e(),_vm._v(" "),(!_vm.isReminder)?_c('ul',{staticClass:"remain w-100"},[_c('div',{staticClass:"remain-title d-flex py-3"},[_c('div',{staticClass:"remain-text mr-4",staticStyle:{"font-size":"20px"}},[_vm._v("\n          สินค้าดังต่อไปนี้ใกล้หมดแล้ว\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-info px-4",staticStyle:{"font-size":"16px","line-height":"25px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.goTo('/order')}}},[_vm._v("\n          สั่งสินค้า\n        ")])]),_vm._v(" "),_c('div',{staticClass:"remain-items"},_vm._l((_vm.remainingData),function(e,i){return _c('li',{key:'re' + i},[_c('p',[_vm._v("- "+_vm._s(e.text)+" คงเหลือ "+_vm._s(e.remain)+" "+_vm._s(e.unit))])])}),0)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"notiCalendarTitle"}},[_vm._v("\n      แจ้งเตือน\n    ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3",style:({ 'min-height': _vm.$store.state.screenHeight - 100 + 'px' })},[_c('div',{staticClass:"card-body text-center"},[_c('h1',{staticStyle:{"font-weight":"bold"}},[_vm._v("เมนูหลัก")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center align-items-start flex-wrap"},_vm._l((_vm.menus),function(m,i){return _c('div',{key:'menu' + i,staticClass:"menu-box d-flex flex-column justify-content-center align-items-center",on:{"click":function($event){return _vm.goTo(m.path)}}},[(m.name == 'การแจ้งเตือน' && parseInt(_vm.notiDetail) > 0)?_c('p',{staticStyle:{"position":"absolute","border":"1px solid #DC3545","border-radius":"50%","width":"fit-content","height":"fit-content","padding":"3px 8px 0px 8px","background-color":"#DC3545","color":"white","font-size":"1.2rem","float":"right","margin-left":"90px","margin-top":"-100px"}},[_vm._v("\n       "+_vm._s(_vm.notiDetail)+"\n      ")]):_vm._e(),_vm._v(" "),_c('i',{class:m.icon,staticStyle:{"font-size":"90px"}}),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(m.name))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"HostList","tabindex":"-1","role":"dialog","aria-labelledby":"HostListTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('HostListView')],1)]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"notiCalendar","tabindex":"-1","role":"dialog","aria-labelledby":"notiCalendarTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"600px"},attrs:{"role":"document"}},[_c('CalendarDayView')],1)]),_vm._v(" "),_c('div',{staticClass:"modal fade stick-up alertPostponse",attrs:{"id":"alertPostponse","tabindex":"-1","role":"dialog","aria-labelledby":"alertPostponseTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"700px"},attrs:{"role":"document"}},[_c('AlertPostponse')],1)]),_vm._v(" "),_c('div',{staticClass:"modal fade stick-up alertSuccess",attrs:{"id":"alertSuccess","tabindex":"-1","role":"dialog","aria-labelledby":"alertSuccessTitle","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"600px"},attrs:{"role":"document"}},[_c('AlertSuccess')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.bd3089050dc364399d2c.js